import { LocationGroupType } from "@src/types.generated";
import { Route } from "nextjs-routes";
import { ReactNode } from "react";
import EarthPinOutlineIcon from "@src/lib/icons/18px/earth-pin-outline";
import CodeBranchOutlineIcon from "@src/lib/icons/18px/code-branch-outline";
import CopyrightOutlineIcon from "@src/lib/icons/18px/copyright-outline";

export const locationGroupTypeDisplayName: Record<LocationGroupType, string> = {
  [LocationGroupType.Brand]: "Brand",
  [LocationGroupType.Franchise]: "Franchise",
  [LocationGroupType.Region]: "Region",
};

export const locationGroupPathName: Record<LocationGroupType, Route> = {
  [LocationGroupType.Brand]: { pathname: "/locations/brands" },
  [LocationGroupType.Franchise]: { pathname: "/locations/franchises" },
  [LocationGroupType.Region]: { pathname: "/locations/regions" },
};

export const locationGroupTypeDisplayNamePlural: Record<
  LocationGroupType,
  string
> = {
  [LocationGroupType.Brand]: "Brands",
  [LocationGroupType.Franchise]: "Franchises",
  [LocationGroupType.Region]: "Regions",
};

export const locationGroupTypeIcon: Record<LocationGroupType, ReactNode> = {
  [LocationGroupType.Region]: <EarthPinOutlineIcon className="size-4" />,
  [LocationGroupType.Franchise]: <CodeBranchOutlineIcon className="size-4" />,
  [LocationGroupType.Brand]: <CopyrightOutlineIcon className="size-4" />,
};
